<template lang="pug">
div
  .sl-title.my-5 Delete Account
  .body-2 We respect your privacy and don't sell your data. Learn more about our <router-link to="/privacy">privacy policy</router-link> here.
  v-dialog(v-model="dialog", width="500")
    template(v-slot:activator="{ on }")
      v-btn.my-5(
        @click="generate",
        color="error",
        x-small,
        outlined,
        v-on="on"
      ) Delete My Account
    v-card
      v-toolbar(dense, flat, dark, color="error") Delete Account
      form(@submit.prevent="submit")
        v-card-text
          div We've just send a 9-digit code to your email. Please enter the code to verify that you're the account's owner.
          v-otp-input(v-model="code", length="9", :should-auto-focus="true")
        v-card-actions
          v-btn(type="submit", color="secondary", :loading="loading", block) Delete My Account
</template>

<script>
export default {
  data() {
    return {
      code: "",
      dialog: false,
      loading: false,
    };
  },
  methods: {
    async generate() {
      try {
        await this.$api.user.custom("generateDeleteCode");
        this.$toast.success("Code sent to your email.");
      } catch (e) {
        this.$toast.error(e.response?.data || "Failed to send code.");
      }
    },
    async submit() {
      if (!this.code) return;
      this.loading = true;
      const params = { code: this.code };
      try {
        await this.$api.user.custom("deleteMyAccount", params);
        this.$toast.success("Account deleted.");
        this.$auth.logout();
      } catch (e) {
        this.$toast.error(e.response?.data || "Failed to delete account.");
      }
      this.loading = false;
    },
  },
};
</script>